export const PRICE_RANGE_RENTAL_100 = "ONE_HUNDRED";
export const PRICE_RANGE_RENTAL_500 = "FIVE_HUNDRED";
export const PRICE_RANGE_RENTAL_1000 = "ONE_THOUSAND";
export const PRICE_RANGE_RENTAL_2000 = "TWO_THOUSAND";
export const PRICE_RANGE_RENTAL_MORE = "MORE";
